import {
  BrowserRouter,
  Navigate,
  Route,
  Routes
} from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";

import "mapbox-gl/dist/mapbox-gl.css";
import ConfirmInstallationPage from "./components/Dashboard/ConfirmInstallationPage";
import SimpleRoofDetectionPage from "./components/Dashboard/SimpleRoofDetectionPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AccessDeniedPage from "./pages/Auth/AccessDeniedPage";
import LoginPage from "./pages/Auth/LoginPage";
import SignupPage from "./pages/Auth/SignupPage";
import OrderHistoryPage from "./pages/Dashboard/OrderHistoryPage";
import DebugPage from "./pages/DebugPage";

// Installer side
import CompareBidsPage from "./components/Dashboard/CompareBidsPage";
import CompareBidsPage2 from "./components/Dashboard/CompareBidsPage2";

import { useAuth } from "./contexts/AuthContext";
import BrowseJobs from "./pages/Installer/BrowseJobs";
import InstallerDashboard from "./pages/Installer/Dashboard";
import InstallerProfile from "./pages/Installer/InstallerProfile";
import JobDetails from "./pages/Installer/JobDetails";
import MyBids from "./pages/Installer/MyBids";

// Root route that sends users to the right dashboard based on role
function RootRoute() {
  const { user, role } = useAuth();

  if (user) {
    const normalizedRole = (
      role ||
      user?.user_metadata?.role ||
      ""
    ).toLowerCase();
    if (normalizedRole === "installer") {
      return <Navigate to="/installer" replace />;
    }
    if (normalizedRole === "homeowner") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Not logged in, or no role yet → show public homeowner quote flow
  return <SimpleRoofDetectionPage onClose={() => window.history.back()} />;
}

function AppInner() {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* Role-aware root: sends installers/homeowners to their dashboards */}
          <Route path="/" element={<RootRoute />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/access-denied" element={<AccessDeniedPage />} />

          <Route
            path="/get-quote"
            element={
              <SimpleRoofDetectionPage onClose={() => window.history.back()} />
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrderHistoryPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/compare-bid"
            element={<CompareBidsPage2 onClose={() => window.history.back()} />}
          />

           <Route
            path="/compare-bids"
            element={<CompareBidsPage onClose={() => window.history.back()} />}
          />


          <Route
            path="/confirm-installation"
            element={
              <ConfirmInstallationPage onClose={() => window.history.back()} />
            }
          />

          <Route path="/debug" element={<DebugPage />} />

          {/* Homeowner dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute roles={["homeowner"]}>
                <SimpleRoofDetectionPage />
              </ProtectedRoute>
            }
          />

          {/* Installer routes */}
          <Route
            path="/installer"
            element={
              <ProtectedRoute roles={["installer"]}>
                <InstallerDashboard user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/installer/jobs"
            element={
              <ProtectedRoute roles={["installer"]}>
                <BrowseJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/installer/jobs/:jobId"
            element={
              <ProtectedRoute roles={["installer"]}>
                <JobDetails user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/installer/bids"
            element={
              <ProtectedRoute roles={["installer"]}>
                <MyBids user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/installer/profile"
            element={
              <ProtectedRoute roles={["installer"]}>
                <InstallerProfile user={user} />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}

export default App;
